export default {
  custWaterProdList: [],
  custWaterProd: {},
  userName: {},
  userId: {}
}
